import { showToastrError } from "../../util/toastr.js";
import { getApiRoot, getSettings } from "../../store/configureStore";

import { prependRoot } from "../../util/prependRoot.js";

function hasNotAllowedCharacter(file) {
    let notAllowedCharacters = ["“", "#", "%", "&", "*", ":", "<", ">", "'", "?", "\\", "/", "{", "|", "}", "~", "+"];
    let illegalCharactersCount = 0;

    notAllowedCharacters.forEach(char => {
        if (file.name.indexOf(char) >= 0) {
            illegalCharactersCount++;
        }
    });

    if (illegalCharactersCount != 0) {
        showToastrError("Bestandsnamen met volgende tekens kunnen niet opgeladen worden. " + notAllowedCharacters.join(" "));
        return true;
    }

    return false;
}

export function uploadOneInfrastructuurFile(context, uploadDocumentAction, dossierId, infrastructuurId, tab, component, file) {
    if (file.size > getSettings().maxAllowedContentLength) {
        showToastrError("Het '" + file.name + "' bestand is te groot. Maximum 100MB per bestand.");
        return;
    }

    if (hasNotAllowedCharacter(file))
        return;

    let data = new FormData();
    data.append(1, file);

    uploadDocumentAction(dossierId, tab, component, infrastructuurId, data)
        .then(result => {
            if (result.success) {
                let documenten = context.state.documenten;
                let folder = documenten.find(x => x.name === component);
                if (!folder.files)
                    folder.files = [];

                const newFileObject = Object.assign({},
                    {
                        createdOn: new Date(),
                        id: null,
                        name: file.name,
                        path: null
                    });

                folder.files = folder.files.filter(x => x.name !== newFileObject.name);
                folder.files.push(newFileObject);

                context.setState(
                    {
                        documenten: documenten,
                        hasUnsavedChanges: true
                    });
            } else {
                showToastrError("De upload van " + file.name + " is mislukt");
            }
        });
}

export function uploadOneVoortgangsrapportFile(context, uploadDocumentAction, voortgangsrapportId, tab, component, file) {
    if (file.size > getSettings().maxAllowedContentLength) {
        showToastrError("Het '" + file.name + "' bestand is te groot. Maximum 100MB per bestand.");
        return;
    }

    if (hasNotAllowedCharacter(file))
        return;

    let data = new FormData();
    data.append(1, file);

    uploadDocumentAction(voortgangsrapportId, tab, component, data)
        .then(result => {
            if (result.success) {
                let documenten = context.state.documenten;
                let folder = documenten.find(x => x.name === component);
                if (!folder.files)
                    folder.files = [];

                const newFileObject = Object.assign({},
                    {
                        createdOn: new Date(),
                        id: null,
                        name: file.name,
                        path: null
                    });

                folder.files = folder.files.filter(x => x.name !== newFileObject.name);
                folder.files.push(newFileObject);

                context.setState(
                    {
                        documenten: documenten,
                        hasUnsavedChanges: true
                    });
            } else {
                showToastrError("De upload van " + file.name + " is mislukt");
            }
        });
}

export function uploadOneFile(context, uploadDocumentAction, dossierId, tab, component, file) {
    if (file.size > getSettings().maxAllowedContentLength) {
        showToastrError("Het '" + file.name + "' bestand is te groot. Maximum 100MB per bestand.");
        return;
    }

    if (hasNotAllowedCharacter(file))
        return;

    let data = new FormData();
    data.append(1, file);

    uploadDocumentAction(dossierId, tab, component, data)
        .then(result => {
            if (result.success) {
                let documenten = context.state.documenten; //todo check to use mergeDeep
                let folder = documenten.find(x => x.name === component);

                if (!folder) {
                    folder = {
                        name: component,
                        files: []
                    };
                    documenten.push(folder);
                }

                if (!folder.files)
                    folder.files = [];

                const newFileObject = Object.assign({},
                    {
                        createdOn: new Date(),
                        id: null,
                        name: file.name,
                        path: null
                    });

                folder.files = folder.files.filter(x => x.name !== newFileObject.name);
                folder.files.push(newFileObject);

                context.setState(
                    {
                        documenten: documenten,
                        hasUnsavedChanges: true
                    });
            } else {
                showToastrError("De upload van " + file.name + " is mislukt");
            }
        });
}

export function deleteOneFile(context, deleteDocument, dossierId, tab, component, fileName) {
    return deleteDocument(dossierId, tab, component, fileName)
        .then(result => {
            if (result.success) {
                let documenten = context.state.documenten;
                let folder = documenten.find(x => x.name === component);
                
                if(folder)
                    folder.files = folder.files.filter(x => x.name != fileName);

                context.setState(
                    {
                        documenten: documenten,
                        hasUnsavedChanges: true
                    });
            } else {
                showToastrError("Verwijderen van bestand " + fileName + " is mislukt");
            }
        });
}

export function deleteOneVoortgangsrapportFile(context, deleteDocument, voortgangsrapportId, tab, component, fileName) {
    deleteDocument(voortgangsrapportId, tab, component, fileName)
        .then(result => {
            if (result.success) {
                let documenten = context.state.documenten;
                let folder = documenten.find(x => x.name === component);
                folder.files = folder.files.filter(x => x.name != fileName);

                context.setState(
                    {
                        documenten: documenten,
                        hasUnsavedChanges: true
                    });
            } else {
                showToastrError("Verwijderen van bestand " + fileName + " is mislukt");
            }
        });
}

export function deleteOneInfrastrucuurFile(context, deleteDocument, dossierId, infrastructuurId, tab, component, fileName) {
    deleteDocument(dossierId, tab, component, infrastructuurId, fileName)
        .then(result => {
            if (result.success) {
                let documenten = context.state.documenten;
                let folder = documenten.find(x => x.name === component);
                folder.files = folder.files.filter(x => x.name != fileName);

                context.setState(
                    {
                        documenten: documenten,
                        hasUnsavedChanges: true
                    });
            } else {
                showToastrError("Verwijderen van bestand " + fileName + " is mislukt");
            }
        });
}

export function getFileUrl(dossierId, tab, folder, documentnaam) {
    return prependRoot("/document/" + dossierId + "/" + tab + "/" + folder + "/" + documentnaam + "/false", getApiRoot());
}

export function getFilesForDossierComponent(component, documenten) {
    if (documenten) {
        const folder = documenten.find(x => x.name === component);
        if (folder) return folder.files;
    }
    return [];
}